import api from '../services/api';

function abrirUrlDocumento(url, ventanaExistente = null) {
  if (ventanaExistente && !ventanaExistente.closed) {
    ventanaExistente.location.href = url;
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function generarPdfRecibo(id) {
  const response = await api.post(`/pdf/recibo/${id}`);

  return response.data;
}

export async function obtenerUrlPdfRecibo(id) {
  const response = await api.post(`/pdf/recibo/${id}/link`);

  return response.data?.url || '';
}

export async function obtenerUrlPdfFirmado(id) {
  const response = await api.post(`/recibos/${id}/firmado/link`);

  return response.data?.url || '';
}

export async function abrirPdfRecibo(id, ventanaExistente = null) {
  const url = await obtenerUrlPdfRecibo(id);

  abrirUrlDocumento(url, ventanaExistente);
}

export async function abrirPdfFirmado(id, ventanaExistente = null) {
  const url = await obtenerUrlPdfFirmado(id);

  abrirUrlDocumento(url, ventanaExistente);
}
